import { DoubleArrow as DoubleArrowIcon } from '@mui/icons-material';
import { ReportsDetails, ReportStatus } from '../../../services/api.types';
import { Button } from '../../Button';
import dayjs from 'dayjs';

export type ReportsInfoListProps = {
  reports: ReportsDetails[];
  onOpenReport: (report: ReportsDetails) => void;
};

export const ReportsInfoList = ({
  reports,
  onOpenReport,
}: ReportsInfoListProps) => {
  return (
    <ul className="flex flex-col list-none px-1">
      {reports.map((r) => (
        <li key={r.reportId}>
          <div className="flex flex-row gap-3 ">
            <div className="w-4 h-4">
              <DoubleArrowIcon
                className={
                  r.status === ReportStatus.DONE
                    ? 'text-blue-primary'
                    : 'text-mui-error'
                }
              />
            </div>
            <Button
              variant="text"
              color={r.status === ReportStatus.DONE ? 'secondary' : 'error'}
              className="p-0 px-2 justify-start"
              onClick={() => onOpenReport(r)}
            >
              {`${dayjs(r.date).format('DD/MM/YYYY')} - ${r.subjectName} - ${
                r.studentName
              }\n`}
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
};
